export default "/staticreactui/static/media/static/media/customer5.727f3171.webp";